import { ANALIZE_STATUS } from '../../enums/analize.enum';

export type FileType = 'file' | 'folder';
export type ViewType = 'grid' | 'table';
export type FileStatus = typeof ANALIZE_STATUS[keyof typeof ANALIZE_STATUS];
export type ActivityType = 'upload' | 'rename' | 'move' | 'delete' | 'comment' | 'status_change' | 'active_change';
export enum UploadDestination {
    STANDARD = 'Actual modelo',
    BETA = 'Nuevo modelo',
}

export type uploadRequestStatusType = 'inProgress' | 'successful' | 'failed';

export interface Activity {
    id: string;
    timestamp: Date;
    userId: string;
    userName: string;
    type: ActivityType;
    details: string;
    oldValue?: string;
    newValue?: string;
}

export interface FileComment {
    id: string;
    userId: string;
    userName: string;
    timestamp: Date;
    text: string;
}

export interface FileItem {
    id: string;
    name: string;
    type: FileType;
    size: number | null;
    modifiedAt: Date;
    path: string;
    summary?: string;
    comments?: string;
    active?: boolean;
    status?: FileStatus;
    modifiedBy?: string;
    topics?: string[];
    activities?: Activity[];
    // Folder-specific properties
    parentId?: string | null;
    childCount?: number;
    // File-specific properties
    fileType?: string;
    mimeType?: string;
    // Enhanced metadata
    createdAt?: Date;
    createdBy?: string;
    tags?: string[];
    permissions?: FilePermissions;
    // Move-related properties
    canMove?: boolean;
    moveRestrictions?: string[];
    uploaded_by?: {
        userId: string;
        fullName: string;
        photo: string;
    };
    document_permissions?: string[];
}

export interface FilePermissions {
    read: boolean;
    write: boolean;
    delete: boolean;
    move: boolean;
    share: boolean;
}

// Enhanced move operation types
export interface MoveOperationResult {
    success: boolean;
    itemId: string;
    itemName: string;
    fromPath: string;
    toPath: string;
    error?: string;
}

export interface BatchMoveResult {
    successful: MoveOperationResult[];
    failed: MoveOperationResult[];
    total: number;
    successCount: number;
    failureCount: number;
}

// Drag and drop types
export interface DragData {
    type: 'internal' | 'external';
    items: FileItem[];
    source?: string;
}

export interface DropTarget {
    id: string;
    type: 'folder' | 'root';
    path: string;
    canAccept: (dragData: DragData) => boolean;
}
